/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

const slider = document.querySelector('.products-slider.splide');

if( slider ) {
    var splide = new Splide( slider , {
        type: 'loop',
        rewind: true,
        speed: 1000,
        arrows: true,
        pagination: false,
        perPage: 4,
        perMove: 1,
        arrowPath: 'M1.41 1.23265e-07L10.32 8.9L1.41 17.81L1.23266e-07 16.4L7.49 8.9L1.43373e-06 1.41L1.41 1.23265e-07Z',
        padding: {
            right: '12%'
        },
        gap: '18px',
        breakpoints: {
            960: {
                perPage: 2,
                padding: {
                    right: '14%'
                },
            },
            480: {
                perPage: 1,
                padding: {
                    right: '25%'
                },
            },
        }
    });
    splide.mount();
}